import { Icon, TIconName } from '@apia/icons';
import { Box, Close, getVariant, Switch, SwitchProps } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { getLabel, toBoolean } from '@apia/util';
import { useState, useEffect } from 'react';

export interface ISwitchBox {
  align?: 'right' | 'left';
  className?: string;
  disabled?: boolean;
  icon?: TIconName;
  label: string;
  notSwitchedLabel?: boolean;
  onClose?: () => unknown;
  onSwitch?: (switched: boolean) => unknown;
  switchedLabel?: string;
  switchProps?: SwitchProps;
  value?: boolean;
}

export const SwitchCard = observer(
  ({
    align = 'left',
    icon,
    label,
    notSwitchedLabel,
    onClose,
    onSwitch,
    switchedLabel,
    switchProps,
    value,
    disabled,
  }: ISwitchBox) => {
    const [isSwitched, setIsSwitched] = useState(toBoolean(value));

    // Keep internal state in sync if the parent changes the `value` prop.
    useEffect(() => {
      setIsSwitched(toBoolean(value));
    }, [value]);

    const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.checked;
      setIsSwitched(newValue);
      if (onSwitch) {
        onSwitch(newValue);
      }
    };

    return (
      <Box
        className="switch__card"
        {...getVariant('layout.common.components.switchCard')}
      >
        {align === 'left' && (
          <Switch
            disabled={disabled}
            checked={isSwitched}
            {...switchProps}
            onChange={handleSwitchChange}
          />
        )}
        <Box className="label__container" title={label}>
          {icon && <Icon name={icon} title="" />}
          {label}
        </Box>
        {((switchedLabel && isSwitched) || align === 'right' || onClose) && (
          <Box className="switch__container">
            {!notSwitchedLabel &&
              (isSwitched
                ? getLabel('lblCanUpdate').text
                : getLabel('lblCannotUpdate').text)}
            {align === 'right' && (
              <Switch
                disabled={disabled}
                checked={isSwitched}
                {...switchProps}
                onChange={handleSwitchChange}
                className="switch"
                title={
                  isSwitched
                    ? getLabel('lblCanUpdate').text
                    : getLabel('lblCannotUpdate').text
                }
              />
            )}
            {onClose && !disabled && (
              <Close disabled={disabled} onClick={onClose} />
            )}
          </Box>
        )}
      </Box>
    );
  },
);
